import * as React from 'react';
import Page from 'components/Page';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';

import { Button, Row, Col, Input, Label, FormGroup} from 'reactstrap';

import BaseService from '../services/BaseService';

import bgimage from '../assets/img/icon/ms-excel.png';
import ReactExport from "react-data-export";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ReportFlow extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isloaded: false,
            date_from: this.returnDate("today"),
            date_to: this.returnDate("today"),
            reportData: [],
            reportTotal: [],
            reportGroup: [],
            reportGroup2:[]
        };
    
        this.handleInputChange = this.handleInputChange.bind(this);     
        this.onPlaque = this.onPlaque.bind(this);  
    }

    onPlaque() { 
        this.componentDidMount(); }

    returnDate(type) {var da = new Date();
        var year = da.getFullYear();
        var month = da.getMonth() + 1;
        var day = da.getDate();
        // var data = new Date(year, month, 0);

        if (da.getMonth() + 1 < 10) {
            month = "0" + (da.getMonth() + 1);}

        if (type === "to") {
            return year + "-" + month + "-" + day;
        } else if (type === "today") {
            return year + "-" + month + "-" + day;
        } else { 
            day = "01"; return year + "-" + month + "-" + day;}
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }     

    renderAPI = () => {

        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");

        fetch(BaseService.ENDPOINT + "admin/statistics/report-flow?ini_date=" + date1 + "&end_date=" + date2, {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.props.user.access_token
            })
        })
        .then(res => res.json())
        .then(res => { 
            this.setState({
                reportData: res.data.results,
                reportTotal: res.data.total,
                reportGroup: res.data.group,
                reportGroup2: res.data.group2,
                isloaded: true  
            })
        })   

        // console.log(BaseService.ENDPOINT + "admin/statistics/report-cash?ini_date=" + date1 + "&end_date=" + date2)
        console.log(this.props.user.access_token)
        
    }

    componentDidMount(){    
        this.renderAPI()
    }

    renderListHeader() {
        if (this.state.isloaded){
            return(
                <thead>
                <tr>
                    <th>Origem</th>
                    <th>Responsável</th>
                    <th>Forma</th>
                    <th>Data</th>
                    <th>Valor</th>
                </tr>
                </thead>
            )
        }
    }
    
    renderListBody() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return this.state.reportData.map((ret)=>{return(
                <tr>
                    <td>{ret.Origem}</td>
                    <td>{ret.Comprador}</td>
                    <td>{ret.Forma}</td>
                    <td>{ret.DataHora}</td>
                    <td align='right'>{numberFormat(ret.Valor)}</td>
                </tr>
            )})

        } else { return <span><strong>Carregando...</strong></span> }
     }    

     renderListFooter() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return(
                <tfoot class='rdp'>
                <tr>
                    <td></td>
                    <td></td>
                    <td><strong>Total</strong></td>
                    <td align='right'><strong>{numberFormat(this.state.reportTotal[0].Total)}</strong></td>
                </tr>
                </tfoot>
            )
        }         
     }

     renderListGroup() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return this.state.reportGroup.map((ret)=>{return(
                <tr>
                    <td>{ret.Registros}</td>
                    <td>{ret.Origem}</td>
                    <td align='right'>{numberFormat(ret.SubTotal)}</td>
                    <td align='right'>{parseFloat(ret.Percentual).toFixed(0)}%</td>
                </tr>
            )})

        } else { return <span><strong>Carregando...</strong></span> }
     }

     renderListGroupFooter() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return(
                <tfoot>
                <tr>
                    <td></td>
                    <td><strong>Total</strong></td>
                    <td align='right'><strong>{numberFormat(this.state.reportTotal[0].Total)}</strong></td>
                    <td></td>
                </tr>
            </tfoot>     
            )
        }
     }   
     
     renderListGroup2() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return this.state.reportGroup2.map((ret)=>{return(
                <tr>
                    <td>{ret.Registros}</td>
                    <td>{ret.Forma}</td>
                    <td align='right'>{numberFormat(ret.SubTotal)}</td>
                    <td align='right'>{parseFloat(ret.Percentual).toFixed(0)}%</td>
                </tr>
            )})

        } else { return <span><strong>Carregando...</strong></span> }
     }

     renderListGroupFooter2() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return(
                <tfoot>
                <tr>
                    <td></td>
                    <td><strong>Total</strong></td>
                    <td align='right'><strong>{numberFormat(this.state.reportTotal[0].Total)}</strong></td>
                    <td></td>
                </tr>
            </tfoot>     
            )
        }
     }
     
    getResults() {
        var dat = [];
        for(var i=0; i<this.state.reportData.length; i++){
            dat.push(
                [
                    { value: this.state.reportData[i].Origem },
                    { value: this.state.reportData[i].Comprador },
                    { value: this.state.reportData[i].Forma },
                    { value: this.state.reportData[i].DataHora },
                    { value: this.state.reportData[i].Valor}
                ]
            )
        }
        const multidataSet = [
            {
                columns: [
                    {   title: "Origem", width: {wch: 15} },
                    {   title: "Responsavel", width: {wch: 35}},
                    {   title: "Forma", width: {wch: 15}},
                    {   title: "Data", width: {wch: 25}},
                    {   title: "Valor", width: {wch: 15}}
                ],
                    data: dat,
            }
        ]
        return multidataSet
    }     
    
    render() {
        return (
            <Page
                title="Relatório de Caixa"
                className="ReportFlow"
                style={{
                    minHeight: '84vh'
                }}>
                <style>{"\
                    table {\
                        background: #FFFFFF;\
                        width: 100%;\
                    }\
                    tr {\
                        border: 1px solid #C9C9C9;\
                    }\
                    th {\
                        // background: green;\
                        // color: #FFFFFF;\
                        font-weight: bold;\
                        border-bottom: 2px solid #C9C9C9;\
                        padding: 15px;\
                    }\
                    td {\
                        max-width: 400px;\
                        overflow: hidden;\
                        text-overflow: ellipsis;\
                        white-space: nowrap;\
                        padding: 10px;\
                    }\
                    tfoot{\
                        font-weight: bold !important;\
                        border-top: 2px solid #C9C9C9;\
                        border-bottom: 2px solid #C9C9C9;\
                        padding: 15px;\
                    }\
                "}</style>

                <Row>

                    <Col sm={3} >
                        <FormGroup>
                            <Label >De: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_from"
                                value={this.state.date_from}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateFrom}
                                max={this.state.date_to}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}   >
                        <FormGroup>
                            <Label>Até: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_to"
                                value={this.state.date_to}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateTo}
                                min={this.state.date_from}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}>
                        <br />
                        <Button
                            outline
                            onClick={this.onPlaque}
                            style={{
                                marginTop: '7px'
                            }}
                        > Procurar</Button>
                    </Col>

                    <Col sm={3}>
                        <br />
                        <ExcelFile 
                            element={
                                <Button 
                                    outline
                                    style={{
                                        marginTop: '7px'
                                    }}
                                    >
                                    <img src={bgimage} alt="excel" />Exportar para Excel</Button>}>
                                <ExcelSheet dataSet={this.getResults()} name="RelatorioCaixa">
                            </ExcelSheet>
                        </ExcelFile>
                    </Col>

                </Row>

                <Row>
                <FormGroup style={{ marginLeft: 15, width: '95%'}}>

                    <Row>
                        <Col sm={6} className="mb-3">
                            <table id='reportGroup2'>
                                <thead>
                                    <tr>
                                        <th>Registros</th>
                                        <th>Forma</th>
                                        <th align='right'>Valor</th>
                                        <th align='right'>Percentual</th>
                                    </tr>
                                </thead>
                                {this.renderListGroup2()}
                                {this.renderListGroupFooter2()}                            
                            </table>
                        </Col>

                        <Col sm={6} className="mb-3">
                            <table id='reportGroup'>
                                <thead>
                                    <tr>
                                        <th>Registros</th>
                                        <th>Origem</th>
                                        <th align='right'>Valor</th>
                                        <th align='right'>Percentual</th>
                                    </tr>
                                </thead>
                                {this.renderListGroup()}
                                {this.renderListGroupFooter()}                            
                            </table>
                        </Col>



                    </Row>

                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <small>
                            <table id='repotList'>
                                {this.renderListHeader()}
                                <tbody>{this.renderListBody()}</tbody>
                                {this.renderListFooter()}
                            </table>
                            </small>
                        </Col>
                    </Row>

                </FormGroup>
                </Row>

            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(ReportFlow)


// WEBPACK FOOTER //
// ./src/pages/ReportFlow.js